export const MOTION = {
  ease: 'power2.out',
  durationSm: 0.4,
  durationMd: 0.8,
  durationLg: 1.2,
  staggerLines: 0.07,
  y: 30,
  yPercent: 100,
};
